export var getWindow = function getWindow() {
  if (typeof window !== 'undefined') {
    return window;
  }

  return null;
};
export var getBody = function getBody() {
  var win = getWindow();

  if (!win) {
    return null;
  }

  var body = window.document.getElementsByTagName('body')[0];
  return body || null;
};
var emptyFlags = {};
export var getFlags = function getFlags() {
  var win = getWindow();

  if (win && 'armorGlobalFlags' in win) {
    return win.armorGlobalFlags;
  }

  return emptyFlags;
};